export const getLocalStorage = (key: string): string | null => localStorage.getItem(key);
